import React, {useState, useEffect} from 'react';
import FoundUsersTable from './FoundUsersTable.mjs';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function TeamInvitationForm({team_id}) 
{
    const { app_user, team, team_member_role, setTeamDisplayRefresh } = useCTAL();

    const [error, setError] = useState();
    const [form_changed_flag, setFormChangedFlag] = useState(false);
    const [send_team_invitation_button_type, setSendTeamInvitationButtonType] = useState("btn btn-sm btn-secondary mt-2");
    const [results_display, setResultsDisplay] = useState(<></>); 
    const [admin_message_display, setAdminMessageDisplay] = useState(<></>); 

    const admin_message_style = { color: 'red' };

    useEffect(() =>
    {
        if (DEBUG) console.log(`TeamInvitationForm - form_changed_flag: ${form_changed_flag}`);
        if (!form_changed_flag)
            setSendTeamInvitationButtonType("btn btn-sm btn-secondary mt-2");
        else
            setSendTeamInvitationButtonType("btn btn-sm btn-primary mt-2");
    }, [form_changed_flag]);
    
    useEffect(() =>
    {
        if (!team) return;

        var is_disabled = true;
        if (team_member_role == "Admin") {
            is_disabled = false;
            setAdminMessageDisplay(<></>);
        }
        else setAdminMessageDisplay(<><span style={admin_message_style}><small>Sending Invitations requires Team Admin privileges</small></span></>)
        
        document.getElementById("user-invitation-first-name").disabled = is_disabled;
        document.getElementById("user-invitation-last-name").disabled = is_disabled;
        document.getElementById("user-invitation-user-name").disabled = is_disabled;
        document.getElementById("user-invitation-mobile-number").disabled = is_disabled;
        document.getElementById("user-invitation-email-address").disabled = is_disabled;
        document.getElementById("user-invitation-contact-pref").disabled = is_disabled;
    }, [team]);

    const refresh = () => { 
        //reset_file_picker();
        reset_results();    
    }

    const reset_results = () => { setResultsDisplay(<></>); }
    const prepend_result = (result) => { setResultsDisplay( <> {result} {results_display} </>) }

    const create_result_success  = (message) => { return <div class="alert alert-success my-1 py-0" role="alert"><small>{message}</small></div>; }
    const create_result_error    = (message) => { return <div class="alert alert-danger  my-1 py-0" role="alert"><small>{message}</small></div>; }
    const create_result_existing = (message) => { return <div class="alert alert-light   my-1 py-0" role="alert"><small>{message}</small></div>; }
    const create_result_mutiple  = (res)     => { return <div class="alert alert-warning my-1 py-0" role="alert"><small>{res.message} <FoundUsersTable found_users={res.users} send_invite={create_team_invitation_by_user}/></small></div>; }

    const handle_response = (res) => { 
        if (DEBUG) {
            console.log(`TeamInvitationForm - res.message: ${res.message}`);

            if ((res.users) && res.users.length > 0) {
                for (var i=0; i < res.users.length; i++) {
                    console.log(`TeamInvitationForm - ${res.users[i].UserFullName}, ${res.users[i].UserName}, ${res.users[i].MobilePhoneNumber}, ${res.users[i].EmailAddress}`);
                }
            }
        }

        switch (res.result)
        {
            case "success"          : prepend_result(create_result_success(res.message)); setTeamDisplayRefresh(true); break;
            case "error"            : prepend_result(create_result_error(res.message));    break;
            case "existing"         : prepend_result(create_result_existing(res.message)); break;
            case "existing-o-invite": prepend_result(create_result_existing(res.message)); break;
            case "multiple-users"   : prepend_result(create_result_mutiple(res));          break;
            default: break;
        }
    }

    const send_team_invitation = (body) => { 
        console.log(`TeamInvitationForm - Send Team Invitation body: ${body}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-upd`, { method: "POST", body: body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: body })
            .then(response => response.json())
            .then(handle_response)
            .catch(setError);
    }

    const create_team_invitation = () => { 
        if (!form_changed_flag) return;

        var type = "send_team_invitation";
        var create_user_id    = app_user.UserID;
        var user_first_name   = document.getElementById("user-invitation-first-name").value;
        var user_last_name    = document.getElementById("user-invitation-last-name").value;
        var user_name         = document.getElementById("user-invitation-user-name").value;

        var user_phone        = document.getElementById("user-invitation-mobile-number").value;
        var user_email        = document.getElementById("user-invitation-email-address").value;

        var user_contact_pref = document.getElementById("user-invitation-contact-pref").value;

        var body = JSON.stringify({type, team_id, create_user_id, user_first_name, user_last_name, user_name, user_phone, user_email, user_contact_pref});

        send_team_invitation(body);

        document.getElementById("user-invitation-first-name").value    = "";
        document.getElementById("user-invitation-last-name").value     = "";
        document.getElementById("user-invitation-user-name").value     = "";
        document.getElementById("user-invitation-mobile-number").value = "";
        document.getElementById("user-invitation-email-address").value = "";

        setFormChangedFlag(false);
    }
    
    const form_changed = () => { 
        setFormChangedFlag(true);
    }

    const create_team_invitation_by_user = (found_user) => { 
        if (!found_user) return;

        var type = "send_team_invitation";
        var create_user_id    = app_user.UserID;
        var user_first_name   = found_user.FirstName;
        var user_last_name    = found_user.LastName;
        var user_name         = found_user.UserName;

        //Only need the UserName (always unique in the app) to make a match
        var user_phone        = "";
        var user_email        = "";
        var user_contact_pref = "Email"; //HARDCODED

        var body = JSON.stringify({type, team_id, create_user_id, user_first_name, user_last_name, user_name, user_phone, user_email, user_contact_pref});

        send_team_invitation(body);
    }

    return (
        <>
            {admin_message_display}

            <div class="input-group input-group-sm" required>
                <span class="input-group-text" >First Name</span>
                <input id="user-invitation-first-name" type="text" class="form-control" placeholder="First Name" aria-label="FirstName" aria-describedby="first-name"/>
            </div>
           
            <div class="input-group input-group-sm mt-1" required>
                <span class="input-group-text" >Last Name</span>
                <input id="user-invitation-last-name" type="text" class="form-control" placeholder="Last Name" aria-label="LastName" aria-describedby="last-name"/>
            </div>
            
            <div class="input-group input-group-sm mt-1" required>
                <span class="input-group-text" >Username</span>
                <input id="user-invitation-user-name" type="text" class="form-control" placeholder="Application Username (if known)" aria-label="LastName" aria-describedby="last-name" onChange={form_changed}/>
            </div>
            
            <div class="input-group input-group-sm mt-1" required>
                <span class="input-group-text" >Mobile #</span>
                <input id="user-invitation-mobile-number" type="tel" class="form-control" placeholder="Mobile Phone Number" aria-label="MobileNumber" aria-describedby="mobile-number" onChange={form_changed}/>
            </div>

            <div class="input-group input-group-sm mt-1" required>
                <span class="input-group-text" >Email</span>
                <input id="user-invitation-email-address" type="email" class="form-control" placeholder="Email Address" aria-label="EmailAddress" aria-describedby="email-address" onChange={form_changed}/>
            </div>
            
            <div class="form-floating mt-1">
                <select id="user-invitation-contact-pref" class="form-select" aria-label="Contact Preference">
                    <option value="Email">Email</option>
                </select>
                <label class="select-floating-label" htmlFor="floatingSelect">Contact Preference</label>
            </div>
            
            <div class="row">
                <div class="col text-end mb-2">                      
                    <a href="#" class={send_team_invitation_button_type} onClick={ () => create_team_invitation() }>Send Team Invitation</a>
                </div>
            </div>

            {results_display}

        </>
    );
}

/* Oct 2, 2023 Removed SMS option temporarily until toll-free phone number approved in AWS Pinpoint
                    <option value="SMS">SMS</option>
*/